export function isString(v) {
    return typeof v === 'string';
}
//# sourceMappingURL=is-string.js.map